//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import React     from 'react';
import PropTypes from '@/components/PropTypes';
import styles    from './styles.module.scss';

export class Component extends React.Component {
    render() {
        return (
            <tbody className={styles.tableBody}>
                {this.props.children}
            </tbody>
        );
    }
}

export const TableBody = Component;

Component.propTypes = {
    children: PropTypes.children,
};

Component.defaultProps = {
    children: null,
};

export default Component;
